import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
var Icon = function() {
    return /*#__PURE__*/ _jsxs("svg", {
        width: "14",
        height: "8",
        viewBox: "0 0 14 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M7 7.5L0 0.5H14L7 7.5Z",
                fill: "#FF66D4"
            }),
            "     "
        ]
    });
};
export default Icon;
